import { exactMatch, any } from '../utils/search/filterSyntax'

const BEDROOM_PRODUCT_TYPES = [
  'Wardrobes',
  'Bed Frames',
  'Bedside Tables',
  'Chests of Drawers',
  'Dressing Tables',
  'Floor Mirror',
  'Side Tables',
  'Table Mirrors'
]

const LIVING_PRODUCT_TYPES = [
  'Armchairs',
  'Bookshelves',
  'Cabinets',
  'Chaises Longues',
  'Chandeliers',
  'Coffee Tables',
  'Consoles',
  'Dining Chairs',
  'Dining Tables',
  'Fireplace',
  'Lounge Chairs',
  'Media Units',
  'Overmantel Mirrors',
  'Paintings',
  'Pendants',
  'Sideboards',
  'Side Tables',
  'Sofas',
  'Wall Mirrors'
]

// Each entry: English `category_hierarchy` path. Level is inferred from
// segment count. Rails passes a { english_segment -> localised_segment } map
// via `data-taxonomy-translations`; we translate each " > "-split segment
// at query-build time so the filter matches the locale-specific Algolia index.
const FAMILY_FILTERS = {
  Bedroom: [
    'Furniture > Beds',
    'Furniture > Tables > Bedside Tables',
    'Home Decor > Mirrors',
    'Furniture > Storage > Wardrobes',
    'Furniture > Storage > Chests of Drawers',
    'Lighting > Ceiling Lights',
    'Furniture > Seating',
    'Art',
    'Furniture > Tables > Dressing Tables',
    'Lighting > Wall Lights',
    'Textiles'
  ],
  Living: [
    'Furniture > Storage > Sideboards',
    'Furniture > Tables > Dining Tables',
    'Lighting > Floor Lamps',
    'Furniture > Seating > Dining Chairs',
    'Furniture > Seating > Sofas',
    'Home Decor > Mirrors',
    'Art',
    'Textiles',
    'Home Decor > Accessories',
    'Furniture > Seating > Armchairs'
  ],
  General: [
    'Furniture > Storage > Sideboards',
    'Furniture > Tables > Dining Tables',
    'Lighting > Ceiling Lights',
    'Furniture > Seating > Dining Chairs',
    'Furniture > Seating > Sofas',
    'Furniture > Storage > Chests of Drawers',
    'Home Decor > Mirrors',
    'Furniture > Seating > Armchairs',
    'Art'
  ]
}

function getProductFamily (productType) {
  const normalized = (productType || '').trim().toLowerCase()
  if (BEDROOM_PRODUCT_TYPES.some(type => type.toLowerCase() === normalized)) {
    return 'Bedroom'
  }
  if (LIVING_PRODUCT_TYPES.some(type => type.toLowerCase() === normalized)) {
    return 'Living'
  }
  return 'General'
}

function translatePath (englishPath, translations) {
  if (!translations) return englishPath
  return englishPath.split(' > ').map(segment => translations[segment] || segment).join(' > ')
}

function pathToClause (englishPath, translations) {
  const level = englishPath.split(' > ').length - 1
  return exactMatch(`category_hierarchy.lvl${level}`, translatePath(englishPath, translations))
}

export function getCompleteTheRoomQuery (productType, translations) {
  const family = getProductFamily(productType)
  const paths = FAMILY_FILTERS[family]
  return any(paths.map(path => pathToClause(path, translations)))
}
